import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import {
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  getProgressionLastElement4s9ggap3esy2 as getProgressionLastElement_0,
} from '../internal/progressionUtil.mjs';
import {
  IntProgressionIterator2ovd1ctrmu51n as IntProgressionIterator,
  LongProgressionIterator2e3slqmdh4zt7 as LongProgressionIterator,
} from './ProgressionIterators.mjs';
import { Iterable1y3qizuf89iou as Iterable } from '../collections/Collections.mjs';
import { getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode } from '../js/coreRuntime.mjs';
import { negate13xrbakfwasjy as negate } from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      fromClosedRange_y6bqsv_k$(rangeStart, rangeEnd, step) {
        return new (IntProgression())(rangeStart, rangeEnd, step);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var IntProgressionClass;
function IntProgression() {
  if (IntProgressionClass === VOID) {
    class $ {
      constructor(start, endInclusive, step) {
        if (step === 0)
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Step must be non-zero.');
        if (step === -2147483648)
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
        this.first_1 = start;
        this.last_1 = getProgressionLastElement(start, endInclusive, step);
        this.step_1 = step;
      }
      iterator_jk1svi_k$() {
        return new (IntProgressionIterator())(this.first_1, this.last_1, this.step_1);
      }
      isEmpty_y1axqb_k$() {
        return this.step_1 > 0 ? this.first_1 > this.last_1 : this.first_1 < this.last_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof IntProgression()) {
          tmp = this.isEmpty_y1axqb_k$() && other.isEmpty_y1axqb_k$() || (this.first_1 === other.first_1 && this.last_1 === other.last_1 && this.step_1 === other.step_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.isEmpty_y1axqb_k$() ? -1 : imul(31, imul(31, this.first_1) + this.last_1 | 0) + this.step_1 | 0;
      }
      toString() {
        return this.step_1 > 0 ? '' + this.first_1 + '..' + this.last_1 + ' step ' + this.step_1 : '' + this.first_1 + ' downTo ' + this.last_1 + ' step ' + (-this.step_1 | 0);
      }
    }
    initMetadataForClass($, 'IntProgression', VOID, VOID, [Iterable()]);
    IntProgressionClass = $;
  }
  return IntProgressionClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      fromClosedRange_mt5zpf_k$(rangeStart, rangeEnd, step) {
        return new (LongProgression())(rangeStart, rangeEnd, step);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var LongProgressionClass;
function LongProgression() {
  if (LongProgressionClass === VOID) {
    class $ {
      constructor(start, endInclusive, step) {
        if (step === 0n)
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Step must be non-zero.');
        if (step === -9223372036854775808n)
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Step must be greater than Long.MIN_VALUE to avoid overflow on negation.');
        this.first_1 = start;
        this.last_1 = getProgressionLastElement_0(start, endInclusive, step);
        this.step_1 = step;
      }
      iterator_jk1svi_k$() {
        return new (LongProgressionIterator())(this.first_1, this.last_1, this.step_1);
      }
      isEmpty_y1axqb_k$() {
        return this.step_1 > 0n ? this.first_1 > this.last_1 : this.first_1 < this.last_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof LongProgression()) {
          tmp = this.isEmpty_y1axqb_k$() && other.isEmpty_y1axqb_k$() || (this.first_1 === other.first_1 && this.last_1 === other.last_1 && this.step_1 === other.step_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.isEmpty_y1axqb_k$() ? -1 : imul(31, imul(31, getBigIntHashCode(this.first_1)) + getBigIntHashCode(this.last_1) | 0) + getBigIntHashCode(this.step_1) | 0;
      }
      toString() {
        return this.step_1 > 0n ? this.first_1.toString() + '..' + this.last_1.toString() + ' step ' + this.step_1.toString() : this.first_1.toString() + ' downTo ' + this.last_1.toString() + ' step ' + negate(this.step_1).toString();
      }
    }
    initMetadataForClass($, 'LongProgression', VOID, VOID, [Iterable()]);
    LongProgressionClass = $;
  }
  return LongProgressionClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance2qx5twdgt0if1,
  Companion_instance_0 as Companion_instancengy76erk0rf3,
  IntProgression as IntProgressionfaq59u1bhfih,
  LongProgression as LongProgression4dpjnpwadpbx,
};
//endregion

//# sourceMappingURL=Progressions.mjs.map
